import { EMapContainerAreaActionType } from 'shared/map-search/actions/mapContainerArea';

import { IApplicationState, TReduxActions } from '../../types/redux';

const initialState: IApplicationState['mapContainerArea'] = null;

export function mapContainerAreaReducer(
  state: IApplicationState['mapContainerArea'] = initialState,
  action: TReduxActions,
): IApplicationState['mapContainerArea'] {
  switch (action.type) {
    case EMapContainerAreaActionType.Changed:
      return action.payload;
  }

  return state;
}
